import { useEffect, useState } from 'react';
import { useAppSelector } from '../redux';

export interface CompilationSelectionLogic {
  value: string;
  handleSelectionOfValue: (value: string) => void;
}

export const useCompilationSelectionLogic = (): CompilationSelectionLogic => {
  const compileType = useAppSelector(
    (state) => state.features.home.practiceData?.value?.compileType
  );

  const [value, setValue] = useState(compileType);

  useEffect(() => {
    setValue(compileType);
  }, [compileType]);

  const handleSelectionOfValue = (newValue: string) => {
    setValue(newValue);
  };

  return {
    value,
    handleSelectionOfValue,
  };
};
